export default __webpack_public_path__ + "static/media/gokce1.0595f5ce.jpg";